module.exports = __webpack_public_path__ + "app/principal/group/sub-entity/modal-group-list-sub-entities-2Vnamiqh.html";